import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
	selector: '[code]',
	standalone: true,
})
export class CodeDirective {

	private regex = new RegExp(/^[a-zA-Z0-9]$/);

	constructor(private el: ElementRef) {

	}

	@HostListener('input', ['$event'])
	onKeyDown(event: any) {

		if (!String(event.data).match(this.regex)) {

			this.el.nativeElement.value = '';

			event.preventDefault();
			return;
		}

		let next = this.el.nativeElement.nextElementSibling;
		if (next) {

			setTimeout(() => {

				next.focus();
			}, 100);
		}
	}

	@HostListener('paste', ['$event'])
	onPaste(event: any) {

		event.preventDefault();
	}
}